import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Routes, Route, NavLink, Navigate, Outlet, useNavigate, useLocation } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./services/firebase";
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/react";
import Trazabilidad from "./components/Trazabilidad/Trazabilidad";
import TrazabilidadNuevo from "./components/Trazabilidad/TrazabilidadNuevo";
import ComprasForm from "./components/Compras/ComprasForm";
import OCForm from "./components/Compras/OCForm";
import Compras from "./components/Compras/Compras";
import Metricas from "./components/Metricas";
import Inventario from "./components/Inventario/Inventario";
import Stock from "./components/Stock/Stock";
import Biblioteca from "./components/Biblioteca/Biblioteca";
import Repositorio from "./components/Repositorio/Repositorio";
import Login from "./components/Login";
import DocDetail from "./components/DocDetail";
import SearchBar from "./components/SearchBar";
import "./App.css";
import "./fonts.css";
import DriudaIcon from "./assets/icons/DriudaIcon.svg";
import { ReactComponent as ComprasIcon } from './assets/icons/ComprasIcon.svg';
import { ReactComponent as VentasIcon } from './assets/icons/VentasIcon.svg';
import { ReactComponent as SearchIcon } from './assets/icons/SearchIcon.svg';
import { ReactComponent as StockIcon } from './assets/icons/StockIcon.svg';
import { ReactComponent as RepositorioIcon } from './assets/icons/RepositorioIcon.svg';
import { ReactComponent as ClientesIcon } from './assets/icons/ClientesIcon.svg';
import { ReactComponent as BiblioIcon } from './assets/icons/BiblioIcon.svg';
import { ReactComponent as ClimaIcon } from './assets/icons/ClimaIcon.svg';
import { ReactComponent as LocationIcon } from './assets/icons/LocationIcon.svg';
import { ReactComponent as MetricasIcon } from './assets/icons/MetricasIcon.svg';
import { ReactComponent as EventosIcon } from './assets/icons/EventosIcon.svg';
import { ReactComponent as CalendarIcon } from './assets/icons/CalendarIcon.svg';
import { ReactComponent as ContactsIcon } from './assets/icons/ContactsIcon.svg';
import { ReactComponent as CheckIcon } from './assets/icons/CheckIcon.svg';
import { ReactComponent as CircleIcon } from './assets/icons/CircleIcon.svg';
import { ReactComponent as InventarioIcon } from './assets/icons/InventarioIcon.svg';
import { ReactComponent as EstadisticasIcon } from './assets/icons/EstadisticasIcon.svg';

import Clientes from "./components/Clientes/Clientes";
import DocEdit from "./components/DocEdit";
import Clima from "./components/Clima";
import Buzziness from "./components/Buzziness";
import { Fragment } from "react";
import LoadingSpinner from "./components/LoadingSpinner";
import InventarioForm from "./components/Inventario/InventarioForm";
import ClientesForm from "./components/Clientes/ClientesForm";
import InventarioDetails from "./components/Inventario/InventarioDetails";
import ClienteDetails from "./components/Clientes/ClienteDetails";
import Home from "./components/Home";
import Chat from "./components/Chat";
import VentasForm from "./components/Ventas/VentasForm";
import Ventas from "./components/Ventas/Ventas";
import ContactSideBar from "./components/ContactSideBar/ContactSideBar";
import CalendarSideBar from "./components/CalendarSideBar/CalendarSideBar";
import TareasSideBar from "./components/TareasSideBar/TareasSideBar";
import EventosForm from "./components/Eventos/EventosForm";
import DegustacionesForm from "./components/Eventos/DegustacionesForm";
import DemostracionesForm from "./components/Eventos/DemostracionesForm";
import Eventos from "./components/Eventos/Eventos";
import NuevoEvento from "./components/Eventos/NuevoEvento";
import EventoDetails from "./components/Eventos/EventoDetails";
import DemostracionesDetails from "./components/Eventos/DemostracionesDetails";
import Perfil from "./components/Perfil";
import EstadisticasVentas from "./components/Estadisticas/EstadisticasVentas";
import EstadisticasCompras from "./components/Estadisticas/EstadisticasCompras";
import EstadisticasInventario from "./components/Estadisticas/EstadisticasInventario";


const opcionesNuevo = [
{ id: 1, label: "Venta", path: "/nueva-venta" },
{ id: 2, label: "Compra", path: "/nueva-compra" },
{ id: 3, label: "Orden de compra", path: "/nueva-orden-de-compra" },
{ id: 4, label: "Trazabilidad", path: "/nueva-trazabilidad" },
{ id: 5, label: "Cliente", path: "/nuevo-cliente" },
{ id: 6, label: "Inventario", path: "/nuevo-inventario" },
{ id: 9, label: "Evento", path: "/nuevos-eventos" },
];
const opcionesEstadisticas = [
  { id: 1, label: "Ventas", path: "/estadisticas-ventas" },
  { id: 2, label: "Compras", path: "/estadisticas-compras" },
  { id: 3, label: "Inventario", path: "/estadisticas-inventario" },
];
const MainLayoutComponent = ({ isLoggedIn, userInitials, searchText, setSearchText }) => {
const dropdownRef = useRef(null);
const dropdownEstRef = useRef(null);
const contactSidebarRef = useRef(null);
const calendarSidebarRef = useRef(null);
const tareasSidebarRef = useRef(null);
const [ContactSideBarVisible, setContactSideBarVisible] = useState(false);
const [CalendarSideBarVisible, setCalendarSideBarVisible] = useState(false);
const [TareasSideBarVisible, setTareasSideBarVisible] = useState(false);
const todayNumber = new Date().getDate();
const navigate = useNavigate()
const location = useLocation();
/* Cajón del menú: sólo se usa en pantallas angostas, donde la columna
   izquierda deja de tener lugar propio y pasa a abrirse por encima. */
const [navAbierto, setNavAbierto] = useState(false);

/* Se cierra al navegar. Mirar la ruta en vez de poner un onClick por botón
   cubre también los desplegables "Nuevo" y "Estadísticas", que navegan por
   código y no por NavLink. */
useEffect(() => {
setNavAbierto(false);
}, [location.pathname]);

useEffect(() => {
if (!navAbierto) return;
const alPresionarTecla = (event) => {
if (event.key === "Escape") setNavAbierto(false);
};
document.addEventListener("keydown", alPresionarTecla);
return () => document.removeEventListener("keydown", alPresionarTecla);
}, [navAbierto]);

useEffect(() => {
const handleClickOutside = (event) => {
if (
contactSidebarRef.current &&
!contactSidebarRef.current.contains(event.target) &&
ContactSideBarVisible
) {
setContactSideBarVisible(false);
}
if (
calendarSidebarRef.current &&
!calendarSidebarRef.current.contains(event.target) &&
CalendarSideBarVisible
) {
setCalendarSideBarVisible(false);
}
if (
tareasSidebarRef.current &&
!tareasSidebarRef.current.contains(event.target) &&
TareasSideBarVisible
) {
setTareasSideBarVisible(false);
}
};
document.addEventListener("mousedown", handleClickOutside);
return () => document.removeEventListener("mousedown", handleClickOutside);
}, [ContactSideBarVisible, CalendarSideBarVisible, TareasSideBarVisible]);
const toggleContactSideBar = () => {
setCalendarSideBarVisible(false);
setTareasSideBarVisible(false);
setContactSideBarVisible(!ContactSideBarVisible);
};
const toggleCalendarSideBar = () => {
setContactSideBarVisible(false);
setTareasSideBarVisible(false);
setCalendarSideBarVisible(!CalendarSideBarVisible);
};
const toggleTareasSideBar = () => {
setContactSideBarVisible(false);
setCalendarSideBarVisible(false);
setTareasSideBarVisible(!TareasSideBarVisible);
};
return (
<div className="app-container">
<header className="app-header">
  <button
    type="button"
    className="nav-toggle"
    aria-label={navAbierto ? "Cerrar menú" : "Abrir menú"}
    aria-expanded={navAbierto}
    onClick={() => setNavAbierto((abierto) => !abierto)}
  >
    <svg viewBox="0 0 20 14" aria-hidden="true" focusable="false">
      <path d="M1 1h18M1 7h18M1 13h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  </button>
  <img src={DriudaIcon} onClick={() => navigate('/')} alt="Driuda Icon" style={{cursor: 'pointer'}} className="driuda-icon" />
  <SearchBar searchText={searchText} setSearchText={setSearchText} />
  <div className="user-circle" title="Ver Perfil" onClick={() => navigate('/perfil')}>
    <span>{userInitials}</span>
  </div>
</header>
<div className="main-layout">
{navAbierto && <div className="nav-backdrop" onClick={() => setNavAbierto(false)} />}
<div className={"sidebar-left" + (navAbierto ? " abierto" : "")}>
<div className="dropdown-new" ref={dropdownRef}>
<Listbox>
{({ open }) => (
<Fragment>
<ListboxButton className="new-button">
<span className="plus-icon"></span> <span className="menu-label">Nuevo</span>
</ListboxButton>
{open && (
<ListboxOptions className="new-dropdown-options">
{opcionesNuevo.map((opcion) => (
<ListboxOption
key={opcion.id}
value={opcion}
className="new-dropdown-option"
onClick={() => navigate(opcion.path)}
>
{opcion.label}
</ListboxOption>
))}
</ListboxOptions>
)}
</Fragment>
)}
</Listbox>
</div>
<NavLink to="/ventas" className={({ isActive }) => "menu-button" + (isActive ? " active" : "")}><VentasIcon className="menu-icon" /> <span className="menu-label">Ventas</span></NavLink>
<NavLink to="/compras" className={({ isActive }) => "menu-button" + (isActive ? " active" : "")}><ComprasIcon className="menu-icon" /> <span className="menu-label">Compras</span></NavLink>
<NavLink to="/trazabilidad" className={({ isActive }) => "menu-button" + (isActive ? " active" : "")}><SearchIcon className="menu-icon" /> <span className="menu-label">Trazabilidad</span></NavLink>
<NavLink to="/clientes" className={({ isActive }) => "menu-button" + (isActive ? " active" : "")}><ClientesIcon className="menu-icon" /> <span className="menu-label">Clientes</span></NavLink>
<NavLink to="/stock" className={({ isActive }) => "menu-button" + (isActive ? " active" : "")}><StockIcon className="menu-icon" /> <span className="menu-label">Stock</span></NavLink>
<NavLink to="/inventario" className={({ isActive }) => "menu-button" + (isActive ? " active" : "")}><InventarioIcon className="menu-icon" style={{height:'16px', margin:'auto 0'}} /> <span className="menu-label">Inventario</span></NavLink>
<NavLink to="/biblioteca" className={({ isActive }) => "menu-button" + (isActive ? " active" : "")}><BiblioIcon className="menu-icon" /> <span className="menu-label">Biblioteca Digital</span></NavLink>
<NavLink to="/repositorio" className={({ isActive }) => "menu-button" + (isActive ? " active" : "")}><RepositorioIcon className="menu-icon" /> <span className="menu-label">Repositorio</span></NavLink>
<NavLink to="/eventos" className={({ isActive }) => "menu-button" + (isActive ? " active" : "")}><EventosIcon className="menu-icon" /> <span className="menu-label">Eventos</span></NavLink>
<NavLink to="/clima" className={({ isActive }) => "menu-button" + (isActive ? " active" : "")}><ClimaIcon className="menu-icon" /> <span className="menu-label">Clima</span></NavLink>
<NavLink to="/buzziness" className={({ isActive }) => "menu-button" + (isActive ? " active" : "")}><LocationIcon style={{height:'15px', margin:'auto 0'}} className="menu-icon" /><span className="menu-label">Buzziness</span></NavLink>

<div className="dropdown-estadisticas" ref={dropdownEstRef}>
  <Listbox>
    {({ open }) => (
      <>
        <ListboxButton className="new-estadisticas-button" style={{marginTop:'20px'}}>
          <EstadisticasIcon className="menu-icon" style={{width:'12px'}} /> <span className="menu-label">Estadísticas</span>
        </ListboxButton>
        {open && (
          <ListboxOptions className="new-estadisticas-dropdown-options">
            {opcionesEstadisticas.map((opcion) => (
              <ListboxOption
                key={opcion.id}
                value={opcion}
                className="new-dropdown-option"
                onClick={() => {
                  navigate(opcion.path);
                }}
              >
                {opcion.label}
              </ListboxOption>
            ))}
          </ListboxOptions>
        )}
      </>
    )}
  </Listbox>
</div>
<NavLink to="/metricas" className={({ isActive }) => "menu-button" + (isActive ? " active" : "")}  style={{margin:'0'}} ><MetricasIcon style={{height:'14px', margin:'auto 0'}} className="menu-icon" /> <span className="menu-label">Métricas</span></NavLink>

</div>
<div className="main-content">
<Outlet context={{ searchText, setSearchText }} />
</div>
<ContactSideBar
ref={contactSidebarRef}
isVisible={ContactSideBarVisible} 
onClose={() => setContactSideBarVisible(false)} 
/>
<CalendarSideBar
ref={calendarSidebarRef}
isVisible={CalendarSideBarVisible}
onClose={() => setCalendarSideBarVisible(false)}
/>
<TareasSideBar
ref={tareasSidebarRef}
isVisible={TareasSideBarVisible}
onClose={() => setTareasSideBarVisible(false)}
/>
<div className="sidebar-right">
<div 
  className={`sidebar-icon-container ${CalendarSideBarVisible ? 'active-icon' : ''}`}
  onClick={toggleCalendarSideBar}
  style={{ position: 'relative', width: '40px', height: '40px' }}
>
  <CalendarIcon className="sidebar-icon" />
  {todayNumber && (
    <span 
      style={{
        position: 'absolute',
        top: '57%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontFamily:'Effra',
        fontSize: '14px',
        fontWeight: 'normal',
        color: 'black',
        pointerEvents: 'none'
      }}
    >
      {todayNumber}
    </span>
  )}
  {/* Tooltip */}
  <span className="calendar-tooltip">
    {new Date().toLocaleDateString('es-AR', { weekday: 'long', month: 'long', day: 'numeric' })}
  </span>
</div>
<div
className={`sidebar-icon-container ${ContactSideBarVisible ? 'active-icon' : ''}`}
onClick={toggleContactSideBar} 
>
<ContactsIcon className="sidebar-icon" />
</div>
<div
className={`sidebar-icon-container ${TareasSideBarVisible ? 'active-icon' : ''}`}
onClick={toggleTareasSideBar}
>
<CheckIcon className="sidebar-icon" />
</div>
<div
className='sidebar-icon-container'
onClick={() => navigate('/chat')} // <-- CAMBIO AQUÍ: Usa navigate('/chat')
>
<CircleIcon className="sidebar-icon" />
</div>
</div>
</div>
</div>
);
};
const MainLayout = React.memo(MainLayoutComponent);

function App() {
const [isLoggedIn, setIsLoggedIn] = useState(null);
const [userInitials, setUserInitials] = useState("");
const [searchText, setSearchText] = useState("");

useEffect(() => {
const auth = getAuth();
const unsubscribe = auth.onAuthStateChanged(async (user) => {
if (user) {
setIsLoggedIn(true);
const userDoc = await getDoc(doc(db, "usuarios", user.uid));
if (userDoc.exists()) {
const { nombre, apellido } = userDoc.data();
const initials = `${nombre?.[0] || ""}${apellido?.[0] || ""}`.toUpperCase();
setUserInitials(initials);
}
} else {
setIsLoggedIn(false);
setUserInitials("");
}
});
return () => unsubscribe();
}, []);
const handleLogout = async () => {
const auth = getAuth();
await auth.signOut();
setIsLoggedIn(false);
setUserInitials("");
};
if (isLoggedIn === null) return <LoadingSpinner />;
const ProtectedRoute = ({ children }) => {
return isLoggedIn ? children : <Navigate to="/login" replace />;
};
return (
<Router>
<Routes>
<Route path="/login" element={isLoggedIn ? <Navigate to="/" /> : <Login onLoginSuccess={() => setIsLoggedIn(true)} />} />
<Route path="/" element={<ProtectedRoute><MainLayout isLoggedIn={isLoggedIn} userInitials={userInitials} searchText={searchText} setSearchText={setSearchText} /></ProtectedRoute>}>
<Route index element={<Home />} />
<Route path="trazabilidad" element={<Trazabilidad />} />
<Route path="inventario" element={<Inventario />} />
<Route path="nueva-trazabilidad" element={<TrazabilidadNuevo />} />
<Route path="nueva-trazabilidad/:tipo" element={<TrazabilidadNuevo />} />
<Route path="nuevo-cliente" element={<ClientesForm />} />
<Route path="nueva-venta" element={<VentasForm />} />
<Route path="compras" element={<Compras />} />
<Route path="chat" element={<Chat />} />
<Route path="ventas" element={<Ventas />} />
<Route path="stock" element={<Stock />} />
<Route path="perfil" element={<Perfil onLogout={handleLogout} />} />
<Route path="biblioteca" element={<Biblioteca />} />
<Route path="repositorio" element={<Repositorio />} />
<Route path="clima" element={<Clima />} />
<Route path="buzziness" element={<Buzziness />} />
<Route path="metricas" element={<Metricas />} />
  <Route path="estadisticas-ventas" element={<EstadisticasVentas />} />
  <Route path="estadisticas-compras" element={<EstadisticasCompras />} />
 <Route path="estadisticas-inventario" element={<EstadisticasInventario />} /> 
<Route path="clientes" element={<Clientes />} />
<Route path="clientes/:id" element={<ClienteDetails />} />
<Route path="nueva-orden-de-compra" element={<OCForm/>} />
<Route path="nuevo-inventario" element={<InventarioForm/>} />
<Route path="nuevos-eventos" element={<NuevoEvento/>} />
<Route path="nuevo-evento" element={<EventosForm/>} />
<Route path="nueva-degustacion" element={<DegustacionesForm/>} />
<Route path="nueva-cata" element={<DemostracionesForm/>} />
<Route path="/compras/editar/:id" element={<ComprasForm/>} />
<Route path="/ordenes-compra/editar/:id" element={<OCForm/>} />
<Route path="/ventas/editar/:id" element={<VentasForm/>} />
<Route path="/eventos/editar/:id" element={<EventosForm/>} />
<Route path="/demostraciones/editar/:id" element={<DemostracionesForm/>} />
<Route path="/degustaciones/editar/:id" element={<DegustacionesForm/>} />
<Route path="eventos" element={<Eventos/>} />
<Route path="/eventos/:id" element={<EventoDetails />} />
<Route path="/demostraciones/:id" element={<DemostracionesDetails />} />
<Route path="nueva-compra" element={<ComprasForm/>} />
<Route path="/trazabilidad/:id" element={<DocDetail />} />
<Route path="/inventario/:id" element={<InventarioDetails />} />
<Route path="/trazabilidad/:coleccion/:id/edit" element={<DocEdit />} />
</Route>
</Routes>
</Router>
);
}
export default App;
